import React from 'react';
import { Route } from 'react-router-dom';
import { checkLocationTokenAndAuthorize, checkWidgetAuthorization } from './utils/check-auth';

export const PrivateRoute = ({ component: Component, store, path, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const tokenAccess = checkLocationTokenAndAuthorize(store, rest);
      if (tokenAccess.access) {
        return <Component {...props} />;
      } else {
        const access = checkWidgetAuthorization(store);
        if (access.access) {
          return <Component {...props} />;
        } else {
          console.log('Neither in cookies nor in storage and nor in url');
          window.location.href = process.env.REACT_APP_ORGANIZATION;
        }
      }
    }}
  />
);
